import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, LoadingController } from 'ionic-angular';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl
} from "@angular/forms";
import { DatabaseProvider } from '../../providers/database/database';
import { AppConfig } from "../../providers/config";

@IonicPage()
@Component({
  selector: 'page-admin-clinics-add',
  templateUrl: 'admin-clinics-add.html',
})
export class AdminClinicsAddPage {

  clinic: any;
  clinicdata: any = {};
  clinicForm: FormGroup;
  clinic_name: FormControl
  phone_number: FormControl;
  address: FormControl;
  address2: FormControl;
  city: FormControl;
  province: FormControl;
  postal_code: FormControl;
  first_name: FormControl;
  last_name: FormControl;
  provinces: any;

  isExisting: boolean = false;
  clinic_id: any = null;
  operation_type: any = 'Add Clinic';

  constructor(
    public viewCtrl: ViewController, 
    public navCtrl: NavController, 
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    private database: DatabaseProvider,
    public loadingCtrl: LoadingController
    ) {
    
    this.provinces = AppConfig.Global.provinces;

    this.clinic_name = new FormControl(
      "",
      Validators.compose([
        Validators.maxLength(50),
        Validators.pattern("[a-zA-Z -]*"),
        Validators.required
      ])
    );
    this.phone_number = new FormControl("");

    this.address = new FormControl("", Validators.required);
    this.address2 = new FormControl("");
    this.city = new FormControl("", Validators.required);
    this.province = new FormControl("", Validators.required);
    this.postal_code = new FormControl("", Validators.required);
    this.first_name = new FormControl("", Validators.required);
    this.last_name = new FormControl("", Validators.required);

    this.clinic = formBuilder.group({
      clinic_name: this.clinic_name,
      phone_number: this.phone_number,
      address: this.address,
      address2: this.address2,
      city: this.city,
      province: this.province,
      postal_code: this.postal_code,
      first_name: this.first_name,
      last_name: this.last_name
    });

    if (this.navParams.get('clinicdata')) {
      const clinic: any = this.navParams.get('clinicdata');
      this.clinic_id = clinic.id;
      console.log("Existing Clinic Info: ", clinic['clinic_name']);
      this.clinicdata['clinic_name'] = clinic['clinic_name'];
      this.clinicdata['phone_number'] = clinic['phone_number'];
      this.clinicdata['address'] = clinic['address']['address'];
      this.clinicdata['address2'] = clinic['address']['address2'];
      this.clinicdata['city'] = clinic['address']['city'];
      this.clinicdata['province'] = clinic['address']['province'];
      this.clinicdata['postal_code'] = clinic['address']['postal_code'];
      this.clinicdata['first_name'] = clinic['pi']['first_name'];
      this.clinicdata['last_name'] = clinic['pi']['last_name'];
      this.clinic.patchValue(this.clinicdata);
    
      this.isExisting = true;
      this.operation_type = "Edit " + this.clinicdata.clinic_name;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AdminClinicsAddPage');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  addClinic()  {
    let clinic = this.clinic.value;

    let newClinic: any = {};
    newClinic.clinic_name = clinic.clinic_name;
    newClinic.phone_number = clinic.phone_number;

    newClinic.address = {};
    newClinic.address.address = clinic.address;
    newClinic.address.address2 = clinic.address2;
    newClinic.address.city = clinic.city;
    newClinic.address.province = clinic.province;
    newClinic.address.postal_code = clinic.postal_code;

    newClinic.pi = {};
    newClinic.pi.first_name = clinic.first_name;
    newClinic.pi.last_name = clinic.last_name;
    console.log(newClinic);
    const loader = this.loadingCtrl.create({});

    loader.present()
    this.database.createClinic(newClinic).then(_ => {
      loader.dismiss().then(() => {
        console.log('Clinic created');
        this.dismiss();
      })
    })
    .catch((err) => {
      loader.dismiss();
      console.log(err);
    })
  }

  updateClinic()  {
    let clinic = this.clinic.value;

    let updateClinic: any = {};
    updateClinic.clinic_name = clinic.clinic_name;
    updateClinic.phone_number = clinic.phone_number;

    updateClinic.address = {};
    updateClinic.address.address = clinic.address;
    updateClinic.address.address2 = clinic.address2;
    updateClinic.address.city = clinic.city;
    updateClinic.address.province = clinic.province;
    updateClinic.address.postal_code = clinic.postal_code;

    updateClinic.pi = {};
    updateClinic.pi.first_name = clinic.first_name;
    updateClinic.pi.last_name = clinic.last_name;
    console.log(updateClinic);
    const loader = this.loadingCtrl.create({});

    loader.present()
    this.database.updateClinic(this.clinic_id, updateClinic).then(_ => {
      loader.dismiss().then(() => {
        console.log('Clinic updated');
        this.dismiss();
      })
    })
    .catch((err) => {
      loader.dismiss();
      console.log(err);
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-clinics-add/admin-clinics-add.ts